import './markdown-ppt.ts'

import { MarkdownPpt } from './markdown-ppt'

export default MarkdownPpt
